var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 1666.667",
    style: {
      enableBackground: "new 0 0 2500 1666.667"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#78C5D9"
    },
    width: 2500,
    height: 1666.667
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7D131"
    },
    points: "1088.7,1035.149 885.273,747.578 681.847,1035.149 762.08,1035.149 762.08,1666.667  1008.467,1666.667 1008.467,1035.149  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2F5481"
    },
    points: "885.273,747.578 681.847,1035.149 208.909,1035.149 440.084,747.578  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.921,
    y: 1035.149,
    style: {
      fill: "#203B51"
    },
    width: 450.159,
    height: 631.518
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 350.434,
    y: 1114.376,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.545,
    y: 1114.376,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.657,
    y: 1114.376,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.561,
    y: 1114.376,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 350.434,
    y: 1208.877,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.545,
    y: 1208.877,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.657,
    y: 1208.877,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.561,
    y: 1208.877,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 350.434,
    y: 1303.377,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.545,
    y: 1303.377,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.657,
    y: 1303.377,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.561,
    y: 1303.377,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 350.434,
    y: 1397.878,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.545,
    y: 1397.878,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.657,
    y: 1397.878,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.561,
    y: 1397.878,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 350.434,
    y: 1492.379,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.545,
    y: 1492.379,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.657,
    y: 1492.379,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.561,
    y: 1492.379,
    style: {
      fill: "#2F5481"
    },
    width: 65.006,
    height: 65.006
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7D131"
    },
    points: "1689.767,1199.742 1539.36,987.12 1388.953,1199.742 1448.274,1199.742  1448.274,1666.667 1630.446,1666.667 1630.446,1199.742  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2F5481"
    },
    points: "1539.36,987.12 1388.953,1199.742 1039.276,1199.742 1210.2,987.12  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1115.44,
    y: 1199.742,
    style: {
      fill: "#203B51"
    },
    width: 332.834,
    height: 466.925
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1143.916,
    y: 1258.32,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1220.153,
    y: 1258.32,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296.391,
    y: 1258.32,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1371.735,
    y: 1258.32,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1143.916,
    y: 1328.191,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1220.153,
    y: 1328.191,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296.391,
    y: 1328.191,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1371.735,
    y: 1328.191,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1143.916,
    y: 1398.062,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1220.153,
    y: 1398.062,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296.391,
    y: 1398.062,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1371.735,
    y: 1398.062,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1143.916,
    y: 1467.933,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1220.153,
    y: 1467.933,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296.391,
    y: 1467.933,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1371.735,
    y: 1467.933,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1143.916,
    y: 1537.804,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1220.153,
    y: 1537.804,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296.391,
    y: 1537.804,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1371.735,
    y: 1537.804,
    style: {
      fill: "#2F5481"
    },
    width: 48.063,
    height: 48.063
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7D131"
    },
    points: "2099.196,1353.508 1998.321,1210.906 1897.445,1353.508 1937.231,1353.508  1937.231,1666.667 2059.41,1666.667 2059.41,1353.508  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2F5481"
    },
    points: "1998.321,1210.906 1897.445,1353.508 1662.923,1353.508 1777.558,1210.906  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.005,
    y: 1353.508,
    style: {
      fill: "#203B51"
    },
    width: 223.226,
    height: 313.159
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1733.103,
    y: 1392.795,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1784.234,
    y: 1392.795,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1835.365,
    y: 1392.795,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.897,
    y: 1392.795,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1733.103,
    y: 1439.656,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1784.234,
    y: 1439.656,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1835.365,
    y: 1439.656,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.897,
    y: 1439.656,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1733.103,
    y: 1486.518,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1784.234,
    y: 1486.518,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1835.365,
    y: 1486.518,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.897,
    y: 1486.518,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1733.103,
    y: 1533.379,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1784.234,
    y: 1533.379,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1835.365,
    y: 1533.379,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.897,
    y: 1533.379,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1733.103,
    y: 1580.24,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1784.234,
    y: 1580.24,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1835.365,
    y: 1580.24,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.897,
    y: 1580.24,
    style: {
      fill: "#2F5481"
    },
    width: 32.235,
    height: 32.235
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F5481"
    },
    d: "M1412.363,684.293c0,0,9.391,281.997,4.715,280.794c-4.677-1.203-21.365-0.982-24.516-1.203 c-3.152-0.221-15.597-230.53-25.006-231.659c-9.445-1.133-31.881,233.585-38.569,232.865c-6.689-0.72-23.896,0.739-24.717-1.206 c-0.822-1.946,18.587-224.497,16.179-226.929c-2.407-2.432-12.136-35.268-3.624-56.55L1412.363,684.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#203B51"
    },
    d: "M1412.427,686.245c0,0-28.499,15.254-53.695,15.699c-25.196,0.445-44.943-8.604-44.943-8.604 s-0.636,7.134-0.291,11.93c0,0,20.904,6.801,45.615,3.622c24.711-3.179,53.314-19.942,53.314-19.942V686.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#254768"
    },
    d: "M1322.215,523.783c0,0-56.99,64.77-52.701,75.493c4.289,10.722,33.377,72.111,37.061,72.244 c3.684,0.133,14.307-12.957,13.662-14.571c-0.645-1.613-17.423-59.297-17.423-59.297s23.231-20.722,24.199-27.498 C1327.98,563.378,1322.215,523.783,1322.215,523.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F5481"
    },
    d: "M1385.133,511.166c0,0,79.505,21.107,80.405,17.958c0.9-3.149-17.992-75.567-15.743-76.916 c2.249-1.349,16.643-6.747,17.992-3.149c1.349,3.598,32.386,81.414,22.94,103.904c-9.446,22.49-95.287,4.948-95.287,4.948 L1385.133,511.166z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#254768"
    },
    d: "M1380.195,451.245c0,0,119.793-40.412,120.654-37.543c0.861,2.869,5.003,24.498,5.003,24.498 c-2.942,2.176-123.935,19.508-123.935,19.508L1380.195,451.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F5481"
    },
    d: "M1496.552,411.867c0,0,5.379,29.257,6.822,29.388c1.443,0.131,5.248-0.394,5.248-1.181 s-4.854-29.912-6.035-30.043C1501.407,409.9,1496.221,410.093,1496.552,411.867z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000069363147861615609630000001722175747007728769_",
    d: "M1348.048,520.993 c-2.507-19.023-6.582-36.156-7.944-49.155c-2.393-22.84,6.609-42.503,20.107-43.917 c13.498-1.414,26.38,15.955,28.773,38.796c0.36,3.438,0.462,6.803,0.329,10.045c-0.532,12.965-10.556,23.551-23.462,24.904 l3.066,16.856L1348.048,520.993z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000069363147861615609630000001722175747007728769_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000013177128081392213280000006548739383581781425_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000069363147861615609630000001722175747007728769_",
    style: {
      overflow: "visible"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#254768"
    },
    d: "M1382.454,444.165c0,0-4.697,36.457-8.832,41.182s-30.42,8.269-31.897,7.974 c-1.477-0.295-17.425-29.794-15.948-49.156c1.477-19.362,27.299-25.638,32.225-25.933c4.926-0.295-6.527,4.327-6.527,4.327 s22.112-6.231,33.641-0.736c9.294,4.43-2.15,3.225-2.15,3.225s12.255,9.675,12.47,17.415 C1395.652,450.203,1382.454,444.165,1382.454,444.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1380.191,465.984c0,0,0.402-10.364-6.565-10.206c-6.967,0.158-2.01,17.843,4.957,17.843 L1380.191,465.984z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F5481"
    },
    d: "M1397.028,524.393c2.431,6.393,2.987,13.846,4.038,20.952 c1.869,12.642,3.676,25.293,5.404,37.955c3.682,26.98,7.508,54.112,9.068,81.316c0.228,3.982,2.57,16.971-1.099,20.137 c-7.492,6.465-36.667,16.817-55.708,17.19c-19.04,0.374-47.628-8.087-51.648-12.079c-4.019-3.992,6.054-81.118,6.997-86.656 c1.687-9.906-0.217-21.232-0.002-31.264c0.389-18.165-0.75-45.298,16.379-56.732c8.467-5.652,19.092-7.678,29.095-8.184 c8.587-0.434,17.732,0.384,25.579,4.139C1391.476,514.201,1394.943,518.907,1397.028,524.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1449.794,452.208c0,0-7.053-3.027-6.473-3.519c0.58-0.492,8.449-1.277,8.701-1.316 c0.252-0.038,4.3-4.816,4.66-7.756c0.36-2.94,1.543-11.764,2.263-12.184c0.72-0.42,2.544-3.463,5.151-3.679 c2.606-0.217,7.844,3.037,8.024,4.597c0.18,1.56-1.578,17.766-5.568,19.707c0,0-5.49,0.261-8.31,1.101 C1455.421,449.997,1449.794,452.208,1449.794,452.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#254768"
    },
    d: "M1403.106,559.328c0,0-18.187-5.418-17.202-2.792s22.533,41.029,23.434,47.903 S1403.332,560.887,1403.106,559.328z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D131"
    },
    d: "M1407.955,560.135c0,0,24.391,60.171,24.668,76.803c0.277,16.632-2.052,17.922-2.836,17.53 s-13.454-14.498-14.237-16.719c-0.784-2.221-7.181-46.946-8.684-51.098l-3.759-27.323L1407.955,560.135z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#254768"
    },
    d: "M1413.449,964.558c0,0-1.457,9.701-0.789,10.202c0.668,0.501,23.214,10.355,24.049,13.528 c0,0-41.418,3.34-42.087,0c-0.668-3.34,0-24.332,0-24.332L1413.449,964.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#254768"
    },
    d: "M1325.053,964.558c0,0-1.457,9.701-0.789,10.202c0.668,0.501,23.214,10.355,24.049,13.528 c0,0-41.418,3.34-42.086,0c-0.668-3.34,0-24.332,0-24.332L1325.053,964.558z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1302.168,300.281c-4.264,3.991-9.927,6.555-15.927,6.398 c-68.831-1.808-135.912,1.095-204.743-0.713c-28.559-0.75-53.464,1.595-83.079-0.008c-8.491-0.46-53.756,1.035-48.555-10.127 c-0.662-2.724,0.123-5.575,1.032-8.227c4.398-12.827,12.287-26.194,22.471-35.377c17.985-16.218,46.999-3.949,47.487,20.644 c5.228-23.559,23.874-42.124,44.684-54.343c9.572-5.62,19.965-10.259,31.001-11.447c16.602-1.787,33.661,4.694,45.736,16.228 c12.075,11.534,19.243,27.768,20.856,44.388c9.971-13.519,22.975-24.788,37.776-32.733c5.917-3.177,12.315-5.874,19.029-6.013 c8.916-0.184,17.454,4.244,23.909,10.396c10.928,10.414,16.609,26.08,14.895,41.078c6.177-5.387,12.663-10.725,20.381-13.483 c7.718-2.758,16.999-2.492,23.371,2.663C1313.631,278.616,1310.696,292.3,1302.168,300.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M835.492,500.81c-0.578,0.594-1.632,0.944-3.306,0.943c-40.021,0-80.039-0.803-120.061-0.723 c-19.541,0.039-39.081,0.391-58.609,1.095c-18.477,0.666-38.556,4.324-56.672-0.569c-6.002-1.621,6.318-14.39,8.449-16.116 c5.27-4.27,12.288-6.541,18.984-5.461c3.822-11.586,11.735-21.35,22.413-27.251c3.787-2.092,8.004-3.707,12.326-3.494 c4.525,0.223,8.701,2.412,12.579,4.754c5.357,3.235,10.602,6.982,14.084,12.183c4.61-6.104,9.682-11.624,15.924-16.045 c3.304-2.34,6.85-4.432,10.748-5.527c3.472-0.975,7.124-1.13,10.729-1.013c9.26,0.3,18.686,2.469,26.284,7.771 c7.599,5.302,13.111,14.068,12.992,23.333c4.812-8.659,15.822-12.771,25.727-12.918c5.053-0.075,10.299,0.824,14.439,3.721 c6.468,4.525,8.95,12.872,10.06,20.687c4.346-2.42,10.063-2.129,14.147,0.725C829.399,488.77,838.384,497.84,835.492,500.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2010.867,661.132c-11.947,7.788-43.279,3.427-53.193,3.427c-67.377,0-134.655,1.803-201.989,1.944 c-16.707,0.035-15.61-9.429-8.523-21.207c6.83-11.35,29.571-18.706,35.377-1.882c6.706-22.591,28.341-38.993,51.585-42.869 c15.44-2.575,33.501,0.947,42.063,14.05c5.091,7.792,5.943,17.518,6.649,26.8c14.279-12.502,30.884-22.339,48.709-28.854 c9.401-3.436,20.568-5.757,28.892-0.198c9.486,6.334,10.69,19.556,10.949,30.959c6.124-1.182,11.557-4.583,17.371-6.839 c5.814-2.256,12.792-3.238,17.99,0.208c2.466,1.635,4.261,4.105,5.716,6.685C2017.52,652.32,2015.944,657.823,2010.867,661.132z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout1);
export default __webpack_public_path__ + "static/media/about1.dcb0ac3a5dd9acb5e81a7db21435b46e.svg";
export { ForwardRef as ReactComponent };